import styled from "styled-components";
import LineBtn from "../../../Button/LineBtn";
import DefaultModalLayout from "../../../Modal/DefaultModalLayout";
import { DefaultModalCommonProps } from "../../Users/UserDetail/CommentModal/CommentModal";
import { ModalLabel } from "../../Users/UserDetail/CommentModal/TargetContainer";
import React, { useState, useEffect } from "react";
import Flex from "../../../DefaultStyles/Flex";
import { Input } from "../../../Input/Input";
import Blank from "../../../DefaultStyles/Blank";
import AlertModal from "../../../Modal/AlertModal";
import { useApi } from "../../../../hooks/useApi";
import { toast } from "react-toastify";
import Loader from "../../../DefaultStyles/Loader";

interface DailyCheckListModalProps extends DefaultModalCommonProps {
  list: string[];
}

export default function DailyCheckListModal({
  closeEvent,
  confirmEvent,
  list,
}: DailyCheckListModalProps) {
  const [inputData, setInputData] = useState<string[]>([]);
  const [askModal, setAskModal] = useState(false);
  const [update, setUpdate] = useState(false);

  const { response, loading, error } = useApi({
    method: "post",
    url: update ? `checklist` : undefined,
    data: {
      list: inputData,
    },
  });

  console.log(inputData);

  useEffect(() => {
    if (list?.length > 0) {
      const temp: string[] = [];
      list?.forEach((l: string, i: number) => {
        temp.push(l);
      });

      console.log(temp);

      setInputData(temp);
    }
  }, [list]);

  useEffect(() => {
    if (response?.status === 200 || response?.status === 201) {
      toast.success("체크리스트가 수정되었습니다.");
      closeEvent();
      if (confirmEvent) confirmEvent();
    }
  }, [response]);

  useEffect(() => {
    if (error) {
      toast.error(error?.data ?? "체크리스트 수정에 실패하였습니다.");
    }
  }, [error]);

  return (
    <>
      <DefaultModalLayout
        modalTitle="체크리스트 편집"
        closeEvent={() => closeEvent()}
        confirmEvent={() => setAskModal(true)}
        isMediumModal
        confirmBtnText="수정하기"
      >
        <ModalLabel>내용</ModalLabel>

        <>
          {inputData?.map((l, i) => (
            <Item key={i}>
              <Input
                placeholder="직접 입력"
                value={l}
                onChange={(e) => {
                  setInputData((prev) => {
                    const temp = [...prev];

                    temp[i] = e.target.value;

                    return [...temp];
                  });
                }}
              />

              <DeleteBtn
                onClick={() => {
                  setInputData((prev) => {
                    const temp = [...prev];

                    temp.splice(i, 1);

                    return [...temp];
                  });
                }}
              >
                <img
                  src={require("../../../../assets/remove_circle_black_24@2x.png")}
                  alt="beta"
                />
              </DeleteBtn>
            </Item>
          ))}
        </>

        <LineBtn
          icon="add"
          btnText="추가"
          btnHeight={38}
          sPadding="0 14px 0 8px"
          style={{ width: "fit-content" }}
          btnClickEvent={() => {
            setInputData((prev) => {
              const temp = [...prev];

              temp.push("");

              return [...temp];
            });
          }}
        />

        <Blank marginHeight={20} blankHeight={20} />
      </DefaultModalLayout>

      {loading && <Loader />}

      {askModal && (
        <AlertModal
          title={"체크리스트가 수정됩니다.\n계속하시겠습니까?"}
          cancelEvent={() => setAskModal(false)}
          btnColor="mint"
          confirmEvent={() => setUpdate(true)}
        />
      )}
    </>
  );
}

const Item = styled(Flex)`
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 12px;
  }
`;

const DeleteBtn = styled.button`
  width: 38px;
  height: 38px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 24px;
    height: 24px;
  }

  &:hover {
    background-color: #f5f5f5;
  }
`;
